import clickOutside from '../helpers/click-outside';

var mobilenavTrigger = document.querySelector(".mobile--menu");
var mobileOverlay = document.querySelector(".nav-overlay");
var secNav = document.querySelector(".secondary-nav");
var bodyClass = document.querySelector("body");

if (mobilenavTrigger) {
    mobilenavTrigger.addEventListener("click", function () {
        document.querySelector(".nav-overlay").classList.toggle("open");
        document.querySelector("body").classList.toggle("n-o");
        this.querySelector(".menu").classList.toggle("open");
        document.querySelector(".main-nav").classList.toggle("open");
        document.querySelector(".secondary-nav").classList.toggle("open");
    });
}

if (mobileOverlay) {
    mobileOverlay.addEventListener("click", function () {
        document.querySelector(".main-nav").classList.remove("open");
        mobileOverlay.classList.remove("open");
        secNav.classList.remove("open");
        mobilenavTrigger.querySelector(".menu").classList.remove("open");
        bodyClass.classList.remove("n-o");
    });
}



// WEBPACK FOOTER //
// ./scripts/components/mobilenav.js